module.exports = __webpack_public_path__ + "img/text3.d2b837ef.png";